import { render, staticRenderFns } from "./HelpCenterLanding.vue?vue&type=template&id=b82c84d6"
import script from "./HelpCenterLanding.vue?vue&type=script&lang=js"
export * from "./HelpCenterLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports